/* @flow */
import * as React from 'react';
import Dialog from 'components/Dialog';
import BoxBody from 'components/BoxBody';
import ShareRemind from 'user/components/ShareRemind';

class ShareRemindModal extends React.Component<$FlowFixMeProps> {
  render() {
    return (
      <Dialog
        eventScreenName="ShareRemindModal"
        className="ShareRemindModal"
        {...this.props}
        size="small">
        <BoxBody>
          <ShareRemind {...this.props} />
        </BoxBody>
      </Dialog>
    );
  }
}

export default ShareRemindModal;
